import {
	RoleApplicationPermissionContext,
	RoleGeneralContextModel,
	RoleGeneralPermissionContext,
	RoleHardwarePermissionContext,
	RoleMemberContext,
	UserRole,
} from '../../../../../model/DeviceAdminModel';
import {
	ContextActionTypes,
	setApplicationPermissionContextModel,
	setClearIsDirtyContextModel,
	setForceRenderContextModel,
	setGeneralPermissionContextModel,
	setHardwarePermissionContextModel,
	setRoleMemberContextModel,
	setRolePropsContextModel,
	setRolesContextModel,
	setSelectedGeneralPermissionContextModel,
} from './actionTypes';

const setForceRenderContextModelAction = (): setForceRenderContextModel => {
	return {
		type: ContextActionTypes.SET_FORCE_RENDER_CONTEXT_MODEL,
	};
};

const setRolesContextModelAction = (payload: UserRole[]): setRolesContextModel => {
	return {
		type: ContextActionTypes.SET_ROLES_CONTEXT_MODEL,
		payload,
	};
};

const setRolePropsContextModelAction = (payload: Partial<RoleGeneralContextModel>): setRolePropsContextModel => {
	return {
		type: ContextActionTypes.SET_ROLE_PROPS_CONTEXT_MODEL,
		payload,
	};
};

const setMemberContextModelAction = (payload: RoleMemberContext): setRoleMemberContextModel => {
	return {
		type: ContextActionTypes.SET_MEMBER_CONTEXT_MODEL,
		payload,
	};
};

const setAppPermissionsAction = (payload: RoleApplicationPermissionContext): setApplicationPermissionContextModel => {
	return {
		type: ContextActionTypes.SET_APPLICATION_PERMISSION_CONTEXT_MODEL,
		payload,
	};
};

const setGeneralPermissionsAction = (payload: Partial<RoleGeneralPermissionContext>): setGeneralPermissionContextModel => {
	return {
		type: ContextActionTypes.SET_GENERAL_PERMISSION_CONTEXT_MODEL,
		payload,
	};
};

const setSelectedGeneralPermissionAction = (payload: number): setSelectedGeneralPermissionContextModel => {
	return {
		type: ContextActionTypes.SET_SELECTED_GENERAL_PERMISSION_CONTEXT_MODEL,
		payload,
	};
};

const setHardwarePermissionsAction = (payload: RoleHardwarePermissionContext): setHardwarePermissionContextModel => {
	return {
		type: ContextActionTypes.SET_HARDWARE_PERMISSION_CONTEXT_MODEL,
		payload,
	};
};

const setClearIsDirtyAction = (): setClearIsDirtyContextModel => {
	return {
		type: ContextActionTypes.SET_CLEAR_IS_DIRTY_CONTEXT_MODEL,
	};
};

export {
	setAppPermissionsAction,
	setClearIsDirtyAction,
	setForceRenderContextModelAction,
	setGeneralPermissionsAction,
	setHardwarePermissionsAction,
	setMemberContextModelAction,
	setRolePropsContextModelAction,
	setRolesContextModelAction,
	setSelectedGeneralPermissionAction,
};
